import React, { useContext } from 'react'

import { DataContext } from '../../../context/DataContext'

const DiscountTicket: React.FC = () => {
  const { companyData, companyColor } = useContext(DataContext)

  const banner = companyData?.storePickupDiscountBanner
  const bgColor = `${companyColor}29`

  if (!banner?.enabled) return null

  return (
    <div
      className='relative w-full portrait:min-h-[100px] landscape:min-h-[150px] rounded-2xl px-6 py-4 flex'
      style={{ backgroundColor: bgColor }}
    >
      <div className="absolute landscape:left-16 portrait:left-8 -top-3 w-6 h-6 landscape:bg-white portrait:bg-[#F7F7F7] rounded-full" />
      <div className="absolute landscape:left-16 portrait:left-8 -bottom-3 w-6 h-6 landscape:bg-white portrait:bg-[#F7F7F7] rounded-full" />
      <div className="absolute landscape:left-[75px] portrait:left-[42px] top-4 bottom-4 border-l-4 border-dotted landscape:border-white portrait:border-[#F7F7F7]" />
      <div className="w-16" />

      <div className="flex-1 flex gap-2 landscape:ml-16 portrait:ml-4">
        <div className="flex flex-col portrait:justify-between landscape:gap-8 items-start">
          <h2 className="text-lg font-[Onest] font-semibold text-black">
            {`Aprovecha un ${banner.percentage}% de descuento`}
          </h2>

          {banner.maxAmount && <h2 className="text-xs font-[Onest] font-semibold text-black">
            {`Con límite de $${Number(banner.maxAmount).toLocaleString('es-CL')}`}
          </h2>}

          {banner.discountCode && <h2 className="text-xs font-[Onest] font-semibold text-black">
            {`Con el código ${banner.discountCode}`}
          </h2>}

          <p className="text-xs font-[Geist] text-black leading-snug whitespace-pre-line pr-10">
            Válido por compras en la tienda el día de retiro. Solo debes presentar este correo en caja
          </p>
        </div>

        {companyData?.logoUrl && (
          <div className="text-sm font-semibold text-black">
            <img src={companyData.logoUrl} alt='top right' className='w-16' />
          </div>
        )}
      </div>
    </div>
  )
}

export default DiscountTicket
